const benefitsHpSection = `
  <div class="benefits">
    <div class="benefits__list">
      <div class="benefits__benefit">
        <img src="/user/documents/img/ico-wrench-check-orange.svg" />
        <h4>Profesionální servis</h4>
      </div>
      <div class="benefits__benefit">
        <img src="/user/documents/img/ico-truck-orange.svg" />
        <h4>Výhradní dovozce</h4>
      </div>
      <div class="benefits__benefit">
        <img src="/user/documents/img/ico-individual-orange.svg" />
        <h4>Vyjímečné produkty a&nbsp;individuální přístup</h4>
      </div>
      <div class="benefits__benefit">
        <img src="/user/documents/img/ico-stopwatch-orange.svg" />
        <h4>Testováno profesionály</h4>
      </div>
    </div>
  </div>
`;

export { benefitsHpSection };
